import parse from "html-react-parser";

export default function LeftSection() {
  const items = [
    '<u>मंडळाची ६० वी वार्षिक सर्वसाधारण सभा </u><br> रविवार, दिनांक ४ ऑक्टोबर रोजी संध्याकाळी ४.३० वाजता आहे',
    '<u>कार्यालय वेळ </u><br>सकाळी ९.३० ते १२.३० व सायंकाळी ४.३० ते ९.००',
    '<u>संपर्क </u><br>भ्रमणध्वनी : ९६१९४४१९५३',
  ];

  return (
    <div className="Cell" style={{ width: "250px" }}>
      <div className="div-LeftPanelHead">पुढील कार्यक्रम</div>
      <div className="div-LeftPanelBody">
        <marquee
          direction="up"
          scrolldelay="100"
          style={{ height: "475px", padding: "5px" }}
        >
          <ul className="SideMarquee">
            {items.map((item, i) => (
              <li key={i}>{parse(item)}</li>
            ))}
          </ul>
        </marquee>
      </div>
    </div>
  );
}
